export function humanize(value) {
  return value
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/(\w+)/g, capitalize)
}

export function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}



// WEBPACK FOOTER //
// ./src/lib/utils/string.js